var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 23.499,
    rx: 8.26855,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#F2F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2C15.9766 2 19 4.87766 19 8.42188C19 12.5 14.5 18.9627 12.8477 21.1948C12.7791 21.2891 12.6892 21.3657 12.5853 21.4186C12.4814 21.4715 12.3665 21.499 12.25 21.499C12.1335 21.499 12.0186 21.4715 11.9147 21.4186C11.8108 21.3657 11.7209 21.2891 11.6523 21.1948C10 18.9636 5.5 12.5033 5.5 8.42188C5.5 4.87766 8.52344 2 12.25 2Z",
    stroke: "#E80505",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.0154C11.0332 11.0154 10.0469 10.0291 10.0469 8.81241C10.0469 7.59571 11.0332 6.60938 12.25 6.60938C13.4668 6.60938 14.4531 7.59571 14.4531 8.81241C14.4531 10.0291 13.4668 11.0154 12.25 11.0154Z",
    stroke: "#E80505",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d689c325474f3fd9cc39f921cd8368b0.svg";
export { ForwardRef as ReactComponent };